import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ClickAnalyticsPlugin } from '@microsoft/applicationinsights-clickanalytics-js';

import history from '../../apphistory';

let reactPlugin = new ReactPlugin();
let appInsights = null;

const clickPluginInstance = new ClickAnalyticsPlugin();
// Click Analytics configuration
const clickPluginConfig = {
    autoCapture: true
};

const createAppInsightsService = () => {

    const init = (connectionString) => {
        if (!connectionString) {
            throw new Error('failed to setup app insights');
        }

        appInsights = new ApplicationInsights({
            config: {
                connectionString: connectionString,
                maxBatchInterval: 0,
                extensions: [reactPlugin, clickPluginInstance],
                enableAutoRouteTracking: false,
                disableAjaxTracking: false,
                autoTrackPageVisitTime: true,
                enableCorsCorrelation: true,
                enableRequestHeaderTracking: true,
                enableResponseHeaderTracking: true,
                useDefaultContentNameOrId: true,
                extensionConfig: {
                    [reactPlugin.identifier]: { history },
                    [clickPluginInstance.identifier]: clickPluginConfig
                }
            }
        });

        appInsights.loadAppInsights();
        appInsights.clearAuthenticatedUserContext();

    };

    return { reactPlugin, appInsights, init };
};

export const appInsightsService = createAppInsightsService();
export const getAppInsights = () => appInsights;
